import styled from 'styled-components';

export const Description =styled.div`
font-weight:bold ;
font-size:20px ;
`